import {createApp} from 'vue'
import ActiveRolesList from './ActiveRolesList'

const el = '.kb-component--active-roles-list'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ActiveRolesListDOM)=> {
            const rolesData = ActiveRolesListDOM.dataset.rolesData 
            ? JSON.parse(ActiveRolesListDOM.dataset.rolesData) 
            : null
            const component = createApp(ActiveRolesList, { rolesData }).use(Store)
            component.mount(ActiveRolesListDOM)
        })
    }
}